import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const menuItems = [
    {
      title: '유앤아이월드',
      submenu: [
        { name: '인사말', id: '인사말' },
        { name: '연혁', id: '연혁' },
        { name: '조직도', id: '조직도' },
        { name: '찾아오시는 길', id: '찾아오시는 길' }
      ]
    },
    {
      title: '후원하기',
      link: 'https://www.ihappynanum.com/Nanum/B/T3T4SOHMUI',
      submenu: [
        { name: '정기후원', id: '후원하기' },
        { name: '일시후원', id: '후원하기' },
        { name: '기업후원', id: '후원하기' },
        { name: '후원안내', id: '후원하기' }
      ]
    }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      {/* Main Navigation */}
      <nav className={`transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="/" className="flex items-center cursor-pointer">
                <img 
                  src="https://dtizen.net/img/uni_logo.png" 
                  alt="유앤아이월드 로고" 
                  className="h-12 w-auto object-contain"
                />
              </a>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center gap-12">
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className="relative"
                  onMouseEnter={() => setActiveMenu(item.title)}
                  onMouseLeave={() => setActiveMenu(null)}
                >
                  <a
                    href={item.link || `#${item.title}`}
                    target={item.link ? "_blank" : undefined}
                    rel={item.link ? "noopener noreferrer" : undefined}
                    className="text-gray-800 font-medium text-base hover:text-blue-600 transition-colors py-2 border-b-2 border-transparent hover:border-blue-600 whitespace-nowrap cursor-pointer"
                  >
                    {item.title}
                  </a>
                  
                  {/* Dropdown Menu */}
                  {activeMenu === item.title && (
                    <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-lg py-2 animate-fadeIn">
                      {item.submenu.map((subItem, subIndex) => (
                        <a
                          key={subIndex}
                          href={`#${subItem.id}`}
                          onClick={(e) => handleMenuClick(e, subItem.id)}
                          className="block px-6 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
                        >
                          {subItem.name}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-gray-800 hover:text-blue-600 w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className="fas fa-bars text-xl"></i>
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}
